import React, { useContext, useState } from 'react';
import { Button, TextField } from '@material-ui/core';
import { MultiStepContext } from '../StepContext4';

export default function Questions4() {
    const { setStep, advertiserData, setAdvertiserData, AdvertisersubmitData } = useContext(MultiStepContext);
    const [error, setError] = useState(null);

    const handleSubmit = () => {
        if (!advertiserData.ans1 || !advertiserData.ans2 || !advertiserData.ans3) {
            setError("Please fill in all fields.");
        } else {
            setError(null);
            AdvertisersubmitData();
        }
    };

    return (
        <div>
            <h4 style={{textAlign:'center'}}>Security Questions</h4>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Primary School Name"
                margin='normal'
                value={advertiserData['ans1'] || ''}
                onChange={(e) => setAdvertiserData({ ...advertiserData, "ans1": e.target.value })}
                variant='outlined'
            />
            </div>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Favourite Food"
                margin='normal'
                value={advertiserData['ans2'] || ''}
                onChange={(e) => setAdvertiserData({ ...advertiserData, "ans2": e.target.value })}
                variant='outlined'
            />
            </div>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Best Friend Name"
                margin='normal'
                value={advertiserData['ans3'] || ''}
                onChange={(e) => setAdvertiserData({ ...advertiserData, "ans3": e.target.value })}
                variant='outlined'
            />
            </div>
            {error && <p style={{color: 'red'}}>{error}</p>}
            <div className="signupbtnn">  
                <Button variant='contained' onClick={() => setStep(1)} color='secondary'>Back</Button>
                <Button variant='contained' style={{float:'right'}} onClick={handleSubmit} color='primary'>Submit</Button> 
            </div>    
        </div>
    );
}
